
import { stateType } from "./operationTrailType";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { directUploadFile, getDuration, previewImage } from "@/utils/util";
import { addTrailData, updateTrailData } from "../../../../api/farmer";
import { useRouter, useRoute } from "vue-router";
import { Toast } from "vant";
import { getFileToken } from "../../../../api/user";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
function stateData() {
  return {
    content: "",
    imageList: [],
    videoList: [],
    uploadSuccessImgList: [],
    uploadSuccessVideoList: [],
    isUpload: false,
    sourceId: "",
    itemData: {},
    videoUrl: "",
    showVideos: false,
  };
}
export default defineComponent({
  components: {
    PreviewVideo,
  },
  setup() {
    const states = reactive<stateType>(stateData());
    const router = useRouter();
    const route = useRoute();
    onMounted(() => {
      // 每次进来时先初始化一下state状态
      Object.assign(states, stateData());
      states.itemData = route.query.item
        ? JSON.parse(route.query.item as string)
        : {};
      states.sourceId = route.params.sourceId as string;
      if (Object.keys(states.itemData).length > 0) {
        states.uploadSuccessImgList = (states.itemData as any).images.map(
          (item: any) => {
            return item.url;
          }
        );
        states.imageList = (states.itemData as any).images.map((item: any) => {
          item.poster = item.url;
          item.progress = 100;
          return item;
        });
        states.videoList = (states.itemData as any).videos.map((item: any) => {
          item.poster = item.coverImg;
          item.progress = 100;
          return item;
        });
        states.content = (states.itemData as any).content;
      }
    });
    return {
      ...toRefs(states),
      ...useEvent(states, router),
    };
  },
});

const useData = (states: stateType) => {
  const uploadVideoFile = async (item: any) => {
    const result: any = await getFileToken({
      bucket: "xfarmer",
      fileType: 1,
      type: 2,
      token: localStorage.getItem("token"),
    });
    if (result.data.code == 0) {
      directUploadFile(item, result.data, { userType: "2", fileType: "1" });
    }
  };

  return {
    uploadVideoFile,
  };
};

const useEvent = (states: stateType, router: any) => {
  const updateTrailDataList = async (params: any) => {
    const result: any = await updateTrailData(params);
    if (result.data.code == 0) {
      Toast.success("已修改");
      const timer = setTimeout(() => {
        router.go(-1);
        clearTimeout(timer);
      }, 1000);
    }
  };
  const saveTrailData = async (params: any) => {
    const result: any = await addTrailData(params);
    if (result.data.code == 0) {
      Toast.success("已保存");
      const timer = setTimeout(() => {
        router.go(-1);
        clearTimeout(timer);
      }, 1000);
    }
  };
  const delVideoBefore = (index: number) => {
    states.uploadSuccessVideoList.splice(index, 1);
    states.videoList.splice(index, 1);
  };
  const onDeleteVideo = (e: any) => {
    states.videoList.splice(e.index, 1);
  };
  const onClickVideo = (e: any) => {
    states.videoUrl = e.url;
    states.showVideos = true;
  };
  const onClickImgPoster = (e: any) => {
    previewImage(
      states.imageList.map((item) => item.url),
      e.index
    );
  };
  const delBefore = (e: any) => {
    states.imageList.splice(e.index, 1);
  };
  const imageUploadAfter = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        const result: any = await getFileToken({
          bucket: "xfarmer",
          fileType: 0,
          type: 2,
          token: localStorage.getItem("token"),
        });
        if (result.data.code == 0) {
          // 执行该函数后，获取数据请直接从双向绑定的数组中取值.
          directUploadFile(item, result.data);
        }
      });
    } else {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: 0,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(e, result.data);
      }
    }
  };

  const { uploadVideoFile } = useData(states);
  const onBeforeUpload = (e: any) => {
    return new Promise<void>((resolve, reject) => {
      let audio = new Audio(URL.createObjectURL(e));
      // 元数据已加载
      audio.addEventListener("loadedmetadata", function (e) {
        let duration = audio.duration;
        if (duration < 2) {
          Toast("视频时长不得小于2秒")
          reject();
        } else {
          resolve();
        }
      });
    });
  };
  const afterUploadVideo = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        uploadVideoFile(item);
      });
    } else {
      uploadVideoFile(e);
    }
  };
  const onSubmit = (values: any) => {
    let params: any = {
      content: states.content,
      imageIds: states.imageList.map((item: any) => item.id).join(","),
      sourceId: states.sourceId,
      videoIds: states.videoList.map((item: any) => item.id).join(","),
    };
    if ((states.itemData as any).id) {
      params.id = (states.itemData as any).id;
      updateTrailDataList(params);
    } else {
      saveTrailData(params);
    }
  };
  return {
    onSubmit,
    imageUploadAfter,
    afterUploadVideo,
    delBefore,
    delVideoBefore,
    onClickImgPoster,
    onDeleteVideo,
    onBeforeUpload,
    onClickVideo,
  };
};
